// if-node-hide.directive.ts
import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { environment } from '@base/environments/environment';

export type NodeId = 'ar' | 'ec' | 'uy' | 'py' | 'do' | 'global' | 'bo';

@Directive({
  selector: '[ifNodeHide]', // uso: *ifNodeHide="['ar','ec']"
})
export class IfNodeHideDirective implements OnInit, OnChanges {
  @Input('ifNodeHide') nodesToHide: NodeId[] = [];
  private hasView = false;
  private readonly NODE = environment.node as NodeId;

  constructor(private tpl: TemplateRef<any>, private vcr: ViewContainerRef) {}

  ngOnInit(): void {
    this.render();
  }

  ngOnChanges(_: SimpleChanges): void {
    this.render();
  }

  private render(): void {
    const SHOULD_HIDE =
      Array.isArray(this.nodesToHide) && this.nodesToHide.includes(this.NODE);

    if (SHOULD_HIDE) {
      // Oculta el contenido si el nodo actual está en la lista
      this.vcr.clear();
      this.hasView = false;
    } else if (!this.hasView) {
      // Muestra el contenido si NO hay que ocultar
      this.vcr.clear();
      this.vcr.createEmbeddedView(this.tpl);
      this.hasView = true;
    }
  }
}
